import React, { Component } from 'react';
import _ from 'lodash';
import {
  Badge,
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip
} from 'reactstrap';
import fileSaver from 'file-saver';
import Select from 'react-select/async';
import Moment from 'moment';
import Service from '../services';
import { ProgressButton } from '../../../commons/ProgressButton';
import DataEmptyState from '../../../commons/dataemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import {
  DatePicker,
  PaginationTotal
} from '../../../commons/controls';
import Lib from '../../../commons/lib';
import NumberFormatter from '../../../commons/NumberFormatter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import TimeFormatter from '../../../commons/TimeFormatter';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

class NyugtaLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalMegtekintes: false,
      modalSztorno: false,
      dataLoaded: null,
      dataViewLoaded: null,
      queryStarted: null,
      kibocsatoOptions: [],
      tipusOptions: [],
      nyugtaJson: [],
      nyugtaViewObj: null,
      nyugtaIds: new Set(),
    };

  }

  componentWillMount() {
    this.initFilter();
  }

  initFilter = () => {
    Service.initNyugtaFilter((err, res) => {
      if (!err) {
        this.setState({
          kibocsatoOptions: res[0].kibocsato && res[0].kibocsato.map(e => (
            <option key={e.id} value={e.id}>
              {e.nev + ' (' + e.cim + ')'}
            </option>
          ))
        });
        this.setState({
          tipusOptions: res[0].tipus.map(e => (
            <option key={e.name} value={e.name}>
              {e.caption}
            </option>
          ))
        });
      }
    });
  }

  updateTable = () => {
    this.setState({
      dataLoaded: false,
      queryStarted: true,
    });

    let filterObj = {};

    if (this.state.bizonylatszamValue) {
      let ids = [];
      ids.push(this.state.bizonylatszamValue.id);
      filterObj.ids = ids;
    } else {
      if (this.state.kibocsatoValue) {
        filterObj.cegid = this.emptyOrNull(this.state.kibocsatoValue);
      }
      if (this.state.tipusValue) {
        filterObj.tipus = this.emptyOrNull(this.state.tipusValue);
      }

      if (this.state.tolValue || this.state.igValue) {
        let kvb = {};
        kvb.sta = this.dateToTimezone(this.state.tolValue);
        kvb.end = this.dateToTimezone(this.state.igValue);
        filterObj.kvb = kvb;
      }
    }

    this.state.nyugtaIds.clear();

    Service.listNyugta(filterObj, (err, res) => {
      if (!err) {
        let rows = [];
        if (res[0] && Array.isArray(res[0])) {
          res[0].forEach((item) => {
            let row = {};
            row.id = item.id;
            row.kibocsato = item.cegnev + '\n(' + item.cegcim + ')';
            row.bizonylatszam = item.bizonylatszam;
            row.osszeg = item.osszeg;
            row.penznem = item.penznem;
            row.tipus = item.tipus;
            row.rogzido = this.timezoneToDate(item.rogzitesidopont);

            rows.push(row);
            this.state.nyugtaIds.add(item.id);
          });
        }
        this.setState({
          nyugtaJson: rows,
          dataLoaded: true,
          queryStarted: false
        });
      } else {
        this.setState({
          dataLoaded: null,
          queryStarted: null
        });
      }
    });
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatIso(date);
  }

  timezoneToDate = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatDateTime(date);
  }

  getCSVFileName = () => {
    if (this.state.bizonylatszamValue) {
      return 'Nyugta_' + this.state.bizonylatszamValue.szam + '.csv';
    }

    return 'Nyugta_lista.csv';
  }

  nyugtaListaXlsx = () => {
    let kvb = {};
    if (this.state.tolValue || this.state.igValue) {
      kvb.sta = this.dateToTimezone(this.state.tolValue);
      kvb.end = this.dateToTimezone(this.state.igValue);
    }

    this.setState({ listButtonLoading: true }, () => {
      Service.listXlsx(Array.from(this.state.nyugtaIds.values()), kvb, (err, res) => {
        this.setState({ listButtonLoading: false });
        if (!err) {
          this.props.globals.addSuccess('Nyugta lista XLSX letöltése...');
          fileSaver.saveAs(new Blob([res[0]], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', responseType: 'arraybuffer' }), 'Nyugtalista_' + Moment().format('YYYYMMDD_HHMMSS') + '.xlsx');
        }
      });
    });
  }

  /**
    * Paraméterben kapott ID-jű nyugta rekord sztornózása
    * @param {number} id
    */
   sztornoNyugta = (id) => {
     this.toggleSztorno();
     Service.sztornoNyugta(id, (err) => {
       if (!err) {
         this.updateTable();
         this.props.globals.addSuccess('Nyugta sztornózva!');
       }
     });
   }

  toggleMegtekintes = () => {
    this.setState({ modalMegtekintes: !this.state.modalMegtekintes });
  }

  toggleSztorno = () => {
    this.setState({
      modalSztorno: !this.state.modalSztorno
    });
  }

  osszegFormatter = (cell, row) => {
    if (cell) {
      if (row.penznem) {
        return NumberFormatter.addSpacesToString(cell, NumberFormatter.OSSZEG) + ' ' + row.penznem;
      }
      return NumberFormatter.addSpacesToString(cell, NumberFormatter.OSSZEG);
    }

    return null;
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell} onClick={() => this.handleViewClick(cell)} />
        <Button className="table-action-icon" id={'action-pdf-' + cell} onClick={() => this.handlePdfClick(cell)}>
          <i class="fa fa-file-pdf-o" />
        </Button>
        <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-view-' + cell} delay={0}>
          Megtekintés
        </UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-pdf-' + cell} delay={0}>
          PDF előállítás
        </UncontrolledTooltip>
        {this.props.globals.hasRole(['SZAMLAZAS_NYUGTA'], true) && row.tipus && !row.tipus.sztorno && (
          <React.Fragment>
            <Button className="table-action-icon" id={'action-sztorno-' + cell + 'level'} onClick={() => this.handleSztornoClick(cell)}>
              <i class="fa fa-times" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'right' }} placement="right" target={'action-sztorno-' + cell + 'level'} delay={0}>
              Sztornózás
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  handleViewClick = (id) => {
    this.setState({ dataViewLoaded: false });
    Service.getNyugta(id, (err, res) => {
      if (!err) {
        this.setState({
          nyugtaViewObj: res[0],
          dataViewLoaded: true
        });
      }
    });
    this.toggleMegtekintes();
  }

  handlePdfClick = (id) => {
    Service.pdfNyugta(id, (err, res) => {
      if (!err) {
        const pdf = new Blob([res[0]], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(pdf);
        window.open(fileURL, '_blank');
      }
    });
  }

  handleSztornoClick = (id) => {
    this._currentSztornoId = id;
    this.toggleSztorno();
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  handleChangeTipus = (e, value) => {
    if (value && value.length !== 0) {
      this.setState({ tipusValue: value });
    } else {
      this.setState({ tipusValue: '' });
    }
  }

  handleChangeKibocsato = (e, value) => {
    if (value && value.length !== 0) {
      this.setState({ kibocsatoValue: value });
    } else {
      this.setState({ kibocsatoValue: '' });
    }
  }

  handleChangeBizonylatszam = (value) => {
    if (value && value.length !== 0) {
      this.setState({ bizonylatszamValue: value });
    } else {
      this.setState({ bizonylatszamValue: '' });
    }
  }

  loadBizonylatszamOptions = (input, callback) => {
    if (input.length !== 0) {
      Service.serachBizonylat(input, (err, res) => {
        if (!err) {
          let options = [];
          for (let [key, value] of Object.entries(res[0])) {
            options.push({ id: key, szam: value });
          }
          callback(options);
        }
      });
    }
  }

  csvKibocsatoDecode = (cell) => {
    return (cell === undefined ? '' : cell.replace('\n', ' '));
  }

  csvTipusDecode = (cell, row) => {
    if (cell === undefined || !row || !row.tipus) {
      return 'Ismeretlen';
    }

    return row.tipus.caption;
  }

  tipusFormatter = (cell) => {
    console.log('cell');
    console.log(cell);
    console.log(cell && cell.color);
    if (cell && cell.color) {
      return <Badge color={cell.color}>{cell.caption}</Badge>;
    }

    return <Badge color="secondary">Ismeretlen</Badge>;
  }

   emptyOrNull = (data) => {
     if (!data || data === '') return null;
     return data;
   }

   renderEloSzures = () => {
     return (
       <RFForm onSubmit={this.updateTable}>
         <div className="row">
           <div className="col-md-3">
             <RFField
               type="select"
               name="kibocsato"
               label={'Kibocsátó:' + (!this.state.bizonylatszamValue ? ' *' : '')}
               onChange={this.handleChangeKibocsato}
               disabled={this.state.bizonylatszamValue}
               defaultSelect={<option value="">{'Válassz kibocsátót...'}</option>}
               selectOptions={this.state.kibocsatoOptions}
             />
           </div>
           <div className="col-md-2">
             <RFField
               type="select"
               name="tipus"
               label="Állapot:"
               onChange={this.handleChangeTipus}
               disabled={this.state.bizonylatszamValue}
               defaultSelect={<option value="">{'Válassz állapotot...'}</option>}
               selectOptions={this.state.tipusOptions}
             />
           </div>
           <div className="col-md-2">
             <DatePicker
               label="Időszak -tól:"
               placeholder="éééé-hh-nn"
               onChange={(e, v) => this.handleDateInputChange(e, v, 'tolValue')}
               value={this.state.tolValue && new Date(this.state.tolValue)}
               name="datumKezdete"
               disabled={this.state.bizonylatszamValue}
             />
           </div>
           <div className="col-md-2">
             <DatePicker
               label="Időszak -ig:"
               placeholder="éééé-hh-nn"
               onChange={(e, v) => this.handleDateInputChange(e, v, 'igValue')}
               value={this.state.igValue && new Date(this.state.igValue)}
               name="datumVege"
               disabled={this.state.bizonylatszamValue}
             />
           </div>
           <div className="col-md-3">
             <Label for="form-field-name">
               Bizonylatszám:
             </Label>
             <Select
               styles={{
                 control: (base, { isDisabled }) => ({
                   ...base,
                   '&:focus': { borderColor: 'red' }, // border style on hover
                   border: '1px solid lightgray', // default border color
                   boxShadow: 'none', // no box-shadow
                   borderRadius: '0',
                   height: '36px !important',
                   minHeight: '36px',
                   backgroundColor: isDisabled ? '#cfd8dc' : null
                 }),
                 placeholder: (defaultStyles) => {
                   return {
                     ...defaultStyles,
                     color: '#345667',
                   };
                 }
               }}
               name="form-field-name"
               id="form-field-name"
               placeholder="Kezdj el gépelni..."
               noOptionsMessage={() => 'Nincs keresési eredmény'}
               searchPromptText="Kezdj el gépelni a kereséshez..."
               loadingMessage={() => 'Keresés...'}
               onChange={v => this.handleChangeBizonylatszam(v)}
               isClearable
               ignoreAccents={false}
               loadOptions={_.debounce(this.loadBizonylatszamOptions, 1000)}
               isLoading={false}
               getOptionLabel={option => option.szam}
               getOptionValue={option => option.id}
               value={this.state.bizonylatszamValue}
               cache={false}
               autoload={false}
             />
           </div>
           {this.state.nyugtaJson.length !== 0 ? (
             <React.Fragment>
               <div className="col-md-6">
                 <ProgressButton className="margin-top-0" color="success" style={{ marginTop: 8, borderRadius: '.2rem' }} loading={this.state.listButtonLoading} onClick={this.nyugtaListaXlsx}>Exportálás XLSX-be</ProgressButton>
               </div>
               <div className="col-md-6" style={{ textAlign: 'right' }}>
                 <Button className="margin-top-0" color="primary" style={{ marginTop: 8 }}>Keresés</Button>
               </div>
             </React.Fragment>
           ) : (
             <div className="col-md-12" style={{ textAlign: 'right' }}>
               <Button className="margin-top-0" color="primary" style={{ marginTop: 8 }}>Keresés</Button>
             </div>
           )}
         </div>
       </RFForm>
     );
   }

   renderAdatok = () => {
     let ny = this.state.nyugtaViewObj;
     return this.state.dataViewLoaded ? (
       <div>
         <h6>Kibocsátó adatok</h6>
         <b>Név: </b>
         {ny && ny.cegnev}
         <br />
         <b>Cím: </b>
         {ny && ny.cegcim}
         <br />
         <b>Adószám: </b>
         {ny && ny.cegadoszam}
         <br />
         <br />
         <h6>Nyugta adatok</h6>
         <b>Forrás: </b>
         {ny && ny.adathelynev}
         <br />
         <b>Állapot: </b>
         {ny && ny.tipus}
         <br />
         <b>Bizonylatszám: </b>
         {ny && ny.bizonylatszam}
         <br />
         <b>Összeg: </b>
         {ny && ny.osszeg && NumberFormatter.formatterSpaceOsszeg(ny.osszeg) + ' ' + ny.penznem}
         <br />
         <br />
         <b>Nyugta kelte: </b>
         {ny && ny.rogzitesidopont && this.timezoneToDate(ny.rogzitesidopont)}
         <br />
         <b>Rögzítő felhasználó: </b>
         {ny && ny.rogzuser}
         <br />
         <br />
         <b>Sztornózás kelte: </b>
         {ny && ny.sztornoidopont && this.timezoneToDate(ny.sztornoidopont)}
         <br />
         <b>Sztornózó felhasználó: </b>
         {ny && ny.sztornouser}
         <br />
       </div>
     ) : this.renderLoader();
   }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value
    });
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'kibocsato',
        style: { whiteSpace: 'pre-wrap', width: '25%' },
        text: 'Kibocsátó',
        csvHeader: 'KIBOCSÁTÓ',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        csvFormat: cell => this.csvKibocsatoDecode(cell),
        sort: true
      },
      {
        dataField: 'bizonylatszam',
        style: { whiteSpace: 'normal' },
        text: 'Bizonylatszám',
        csvHeader: 'BIZONYLATSZÁM',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'rogzido',
        style: { whiteSpace: 'normal', textAlign: 'center' },
        text: 'Kelte',
        csvHeader: 'KELTE',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'osszeg',
        style: { whiteSpace: 'normal', textAlign: 'right' },
        text: 'Összeg',
        csvHeader: 'ÖSSZEG',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
        formatter: this.osszegFormatter
      },
      {
        dataField: 'penznem',
        style: { whiteSpace: 'normal', textAlign: 'right', width: '10%' },
        text: 'Pénznem',
        csvHeader: 'PÉNZNEM',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        hidden: true,
      },
      {
        dataField: 'tipus',
        style: { whiteSpace: 'normal', textAlign: 'center' },
        dataAlign: 'center',
        text: 'Állapot',
        formatter: this.tipusFormatter,
        export: false,
      },
      {
        dataField: 'id',
        style: { whiteSpace: 'normal', textAlign: 'center', width: '120px' },
        text: 'Kelte',
        csvHeader: 'Műveletek',
        formatter: this.iconFormatter,
        csvFormat: (cell, row) => this.csvTipusDecode(cell, row)
      },
    ];

    return this.state.nyugtaJson.length ? (
      <div>
        <BootstrapTable2
          bootstrap4
          keyField="id"
          data={this.state.nyugtaJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          withoutTabIndex
          exportCSV
          csvFileName={this.getCSVFileName}
        />

        <Modal isOpen={this.state.modalSztorno} toggle={this.toggleSztorno} className={this.props.className} backdrop="static">
          <ModalHeader>
            Sztornózás
          </ModalHeader>
          <ModalBody>
            Valóban sztornózni kívánod a kiválasztott nyugtát?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.sztornoNyugta(this._currentSztornoId)}>
              OK
            </Button>
            <Button type="button" color="secondary" onClick={this.toggleSztorno}>
              Mégsem
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    ) : <DataEmptyState />;
  }

  renderLoader = () => {
    return (
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderEloSzures()}
        <div className="row">
          <div className="col-md-12" style={{ marginTop: 8 }}>
            { this.state.queryStarted ? this.renderLoader() : this.state.dataLoaded ? this.renderTable() : <QueryEmptyState /> }
          </div>
        </div>

        <Modal isOpen={this.state.modalMegtekintes} toggle={this.toggleMegtekintes} className={this.props.className} backdrop="static">
          <ModalHeader>Megtekintés</ModalHeader>
          <ModalBody>{this.state.modalMegtekintes ? this.renderAdatok() : <div />}</ModalBody>
          <ModalFooter><Button type="button" color="primary" onClick={this.toggleMegtekintes} className="btn-cursor-pointer">Vissza</Button></ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default NyugtaLista;
